var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) GeoMobile GmbH, 2022
 */
import { useState } from 'react';
import 'react-dropzone-uploader/dist/styles.css';
import Dropzone from 'react-dropzone-uploader';
import DiscordWebhook from 'discord-webhook-ts';
import { store } from '../../core/AppStore';
import axios from 'axios';
import { webHookRequest } from '../../api/models/WebHookRequest';
function fixComponent(component) {
    var _a;
    return (_a = component.default) !== null && _a !== void 0 ? _a : component;
}
export var DropzoneFix = fixComponent(Dropzone);
export var UploadView = function (props) {
    var hook = new DiscordWebhook(process.env.BASE_DISCORD_API_WEBHOOK_URL);
    var _a = useState(null), file = _a[0], setFile = _a[1];
    var _b = useState([]), errors = _b[0], setErrors = _b[1];
    var _c = useState([]), successes = _c[0], setSuccesses = _c[1];
    var _d = useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var _e = useState(false), dev = _e[0], setDev = _e[1];
    var _f = useState(false), test = _f[0], setTest = _f[1];
    var _g = useState(false), prod = _g[0], setProd = _g[1];
    var _h = useState(false), isUpdatePreview = _h[0], setIsUpdatePreview = _h[1];
    var endpoints = [
        {
            name: 'DEV',
            url: 'https://dev.service.ivanto.de/transitfeedservices/api/v1/upload',
            value: dev,
        },
        {
            name: 'TEST',
            url: 'https://test.service.ivanto.de/transitfeedservices/api/v1/upload',
            value: test,
        },
        {
            name: 'PROD',
            url: 'https://service.ivanto.de/transitfeedservices/api/v1/upload',
            value: prod,
        },
    ];
    var handleChangeStatus = function (file, status, meta) {
        setIsUpdatePreview(!isUpdatePreview);
        if (status === 'removed') {
            setFile(null);
            setSuccesses([]);
            setErrors([]);
        }
        if (status === 'aborted') {
            setFile(null);
        }
        if (status === 'done') {
            setFile(file.file);
        }
    };
    var handleSuccess = function (name) {
        var _a;
        setSuccesses(function (prevSuccesses) { return __spreadArray(__spreadArray([], prevSuccesses, true), [
            {
                env: name,
                message: "VDV-Daten wurden erfolgreich hochgeladen.",
            },
        ], false); });
        var webhook = webHookRequest("[".concat((_a = props.tenantId) === null || _a === void 0 ? void 0 : _a.toUpperCase(), "] [").concat(name, "] [SUCCESS] VDV Upload Status"), 'VDV-Daten wurden erfolgreich hochgeladen.', 1673044);
        hook.execute(webhook);
    };
    var handleError = function (name, error) {
        var _a, _b;
        if (error.response) {
            setErrors(function (prevErrors) { return __spreadArray(__spreadArray([], prevErrors, true), [error.response.data], false); });
            var webhook = webHookRequest("[".concat((_a = props.tenantId) === null || _a === void 0 ? void 0 : _a.toUpperCase(), "] [").concat(name, "] [ERROR] VDV Upload Status"), JSON.stringify(error.response.data, null, 2), 15597568);
            hook.execute(webhook);
        }
        else {
            setErrors(function (prevErrors) { return __spreadArray(__spreadArray([], prevErrors, true), [
                {
                    exception: '',
                    message: error.message,
                    displayMessage: '',
                    requestId: error.code,
                    displayRequestId: true,
                    displayDeveloperMessage: true,
                },
            ], false); });
            var webhook = webHookRequest("[".concat((_b = props.tenantId) === null || _b === void 0 ? void 0 : _b.toUpperCase(), "] [").concat(name, "] [ERROR] VDV Upload Status"), error.message, 15597568);
            hook.execute(webhook);
        }
    };
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var formData, _i, endpoints_1, endpoint, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    e.stopPropagation();
                    formData = new FormData();
                    formData.append('file', file);
                    setSuccesses([]);
                    setErrors([]);
                    setIsLoading(true);
                    _i = 0, endpoints_1 = endpoints;
                    _a.label = 1;
                case 1:
                    if (!(_i < endpoints_1.length)) return [3 /*break*/, 6];
                    endpoint = endpoints_1[_i];
                    if (!endpoint.value) return [3 /*break*/, 5];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, axios.post(endpoint.url, formData, {
                            params: {
                                tenant: props.tenantId,
                            },
                            headers: {
                                Authorization: 'Basic ' + store.getState().authState.token,
                                'Content-Type': 'multipart/form-data',
                            },
                        })];
                case 3:
                    _a.sent();
                    handleSuccess(endpoint.name);
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    handleError(endpoint.name, error_1);
                    return [3 /*break*/, 5];
                case 5:
                    _i++;
                    return [3 /*break*/, 1];
                case 6:
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var renderSuccesses = function () {
        if (!successes.length) {
            return _jsx(_Fragment, {});
        }
        return (_jsx("div", { children: successes.map(function (success, index) { return (_jsxs("div", { className: 'border-l-4 mt-4 border-green-400 bg-green-50 p-4', role: 'alert', children: [_jsx("p", { className: 'text-sm text-green-700', children: success.message }), _jsxs("p", { className: 'text-xs text-green-700', children: ["Environment: ", success.env] })] }, index)); }) }));
    };
    var renderErrors = function () {
        if (!errors.length) {
            return _jsx(_Fragment, {});
        }
        return (_jsx("div", { children: errors.map(function (error, index) { return (_jsxs("div", { className: 'bg-red-100 mt-4 border-l-4 border-red-500 text-red-700 p-4', role: 'alert', children: [error.displayMessage ? (_jsx("p", { className: 'truncate text-sm font-bold', children: error.displayMessage })) : undefined, error.message ? (_jsx("p", { className: 'truncate text-sm font-medium mb-2', children: error.message })) : undefined, error.exception ? (_jsx("p", { className: 'truncate text-sm mb-2', children: error.exception })) : undefined, error.requestId ? _jsx("p", { className: 'truncate text-xs', children: error.requestId }) : undefined] }, index)); }) }));
    };
    var renderUpload = function () {
        var _a;
        return (_jsxs("div", { className: 'px-4 sm:px-6 lg:px-8', children: [_jsx("div", { className: 'sm:flex sm:items-center', children: _jsxs("div", { className: 'sm:flex-auto', children: [_jsxs("h1", { className: 'text-xl font-semibold text-gray-900', children: ["Datenimport f\u00FCr ", (_a = props.tenantId) === null || _a === void 0 ? void 0 : _a.toUpperCase()] }), _jsx("p", { className: 'mt-2 text-sm text-gray-700', children: "Automatischer Datenimport f\u00FCr die IBIS-Daten der Apps. Bitte laden Sie die VDV-Daten als ZIP-Datei hoch." })] }) }), _jsx("div", { className: 'mt-8 flex flex-col', children: _jsx(DropzoneFix, { multiple: false, maxFiles: 1, canRestart: false, onChangeStatus: handleChangeStatus, onSubmit: handleSubmit, accept: '.zip', inputContent: 'VDV-Daten auswählen und hochladen (.zip)' }) }), _jsxs("fieldset", { className: 'space-y-5', children: [_jsx("legend", { className: 'sr-only', children: "Server" }), _jsxs("div", { className: 'relative flex items-start', children: [_jsx("div", { className: 'flex h-5 items-center', children: _jsx("input", { id: 'dev', "aria-describedby": 'dev', name: 'dev', type: 'checkbox', checked: dev, onChange: function (e) { return setDev(e.target.checked); }, className: 'h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500' }) }), _jsx("div", { className: 'ml-3 text-sm', children: _jsx("label", { htmlFor: 'dev', className: 'font-medium text-gray-700 uppercase', children: "DEV" }) })] }), _jsxs("div", { className: 'relative flex items-start', children: [_jsx("div", { className: 'flex h-5 items-center', children: _jsx("input", { id: 'test', "aria-describedby": 'test', name: 'test', type: 'checkbox', checked: test, onChange: function (e) { return setTest(e.target.checked); }, className: 'h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500' }) }), _jsx("div", { className: 'ml-3 text-sm', children: _jsx("label", { htmlFor: 'test', className: 'font-medium text-gray-700', children: "TEST" }) })] }), _jsxs("div", { className: 'relative flex items-start', children: [_jsx("div", { className: 'flex h-5 items-center', children: _jsx("input", { id: 'prod', "aria-describedby": 'prod', name: 'prod', type: 'checkbox', checked: prod, onChange: function (e) { return setProd(e.target.checked); }, className: 'h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500' }) }), _jsx("div", { className: 'ml-3 text-sm', children: _jsx("label", { htmlFor: 'prod', className: 'font-medium text-gray-700', children: "PROD" }) })] })] }), isLoading && (_jsxs(_Fragment, { children: [_jsx("div", { className: 'border-l-4 mt-4 border-blue-400 bg-blue-50 p-4', children: _jsx("p", { className: 'text-sm text-blue-700', children: "Das Hochladen der VDV-Daten wird durchgef\u00FChrt. Dieser Vorgang kann etwas Zeit in Anspruch nehmen." }) }), _jsx("button", { type: 'button', disabled: true, className: 'inline-flex mt-5 rounded-md border border-transparent bg-indigo-600 px-4 py-3 text-sm font-medium leading-4 text-white shadow-sm disabled:opacity-50', children: "Laden..." })] })), renderSuccesses(), renderErrors(), file && !isLoading ? (_jsx("button", { type: 'button', onClick: handleSubmit, disabled: !dev && !test && !prod, className: 'inline-flex mt-5 rounded-md border border-transparent bg-indigo-600 px-4 py-3 text-sm font-medium leading-4 text-white shadow-sm disabled:opacity-50', children: "Hochladen" })) : undefined] }));
    };
    return renderUpload();
};
